import React, { createRef } from 'react'
//import PropTypes from 'prop-types'
import Slider from 'react-slick'
import './style.scss'

class MarketingVC extends React.Component {
  constructor(props) {
    super(props)
    this.sliderRef = createRef()
    this.state = {
      marketing: [],
    }
  }

  componentDidMount() {
    // Rest API Params
    fetch(`/wp-json/dhsv/v2/lek023/marketing`)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.setState({
          marketing: data,
        })
      })
      .catch(function (err) {
        console.log('Error: ', err) // eslint-disable-line
      })

    // SLider
    const { sliderRef } = this
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0, true)
    }
  }

  render() {
    const { marketing } = this.state
    console.log(marketing) //eslint-disable-line
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      nextArrow: <div></div>,
      prevArrow: <div></div>,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    }

    return (
      <div className="dhsv_vc_marketing">
        {marketing.length > 3 ? (
          <Slider
            className="dhsv_vc_marketing_container"
            {...settings}
            lazyLoad="ondemand"
            ref={this.sliderRef}
          >
            {marketing.map((marketingitem, i) => (
              <div
                key={i}
                className="dhsv_vc_marketing_item"
                onClick={() => {
                  const pdfurl = marketingitem.pdf
                  window.open(pdfurl, '_blank')
                }}
              >
                <img
                  className="dhsv_vc_marketing_img"
                  src={marketingitem.image}
                />
                <h3>{marketingitem.title}</h3>
              </div>
            ))}
          </Slider>
        ) : (
          <div className="dhsv_vc_marketing_container">
            {marketing.map((marketingitem, i) => (
              <div
                key={i}
                className="dhsv_vc_marketing_item dhsv_vc_marketing_item_no_slider"
                onClick={() => {
                  const pdfurl = marketingitem.pdf
                  window.open(pdfurl, '_blank')
                }}
              >
                <img
                  className="dhsv_vc_marketing_img"
                  src={marketingitem.image}
                />
                <h3>{marketingitem.title}</h3>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }
}

MarketingVC.propTypes = {}

export default MarketingVC
